import styled from 'styled-components';
import { FLUENT_UI_EMOJIS } from '../../../../../assets';

export const EnvelopeIcon = styled(FLUENT_UI_EMOJIS.ENVELOPE_WITH_ARROW)`
  width: 112px;
  height: 112px;
`;
